/**************************************************************************************************
//
//  Description:  Page Routing class
//
//  Copyright:    � 2020 - 2021 Aligned Assets Limited
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier            Issue# Description
//#region Version 1.0.0.0 changes
//    001   19.10.20 Peter Bryden               Initial Revision.
//    002   19.01.21 Sean Flook                 Corrected spelling of Gazetteer.
//#endregion Version 1.0.0.0 changes
//
//--------------------------------------------------------------------------------------------------
//#endregion */

/* #region imports */
import React from "react";
import { Route, Switch } from "react-router-dom";
import { withRouter } from "react-router-dom";

import Homepage from "./pages/Homepage";
import Gazetteerpage from "./pages/Gazetteerpage";
import Taskmanagementpage from "./pages/Taskmanagementpage";
import UserAdminpage from "./pages/UserAdminpage";
import Maintenancepage from "./pages/MaintenancePage";

import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';


/* #endregion imports */


export const HomeRoute = "/";
export const GazetteerRoute = "/gazetteer";
export const TaskManagementRoute = "/taskmanagement";
export const UserAdminRoute = "/useradmin";
export const MaintenanceRoute = "/maintenance";

export const CurrentRoute = () => {
  const currentRoute = window.location.pathname;

  if (currentRoute.startsWith(GazetteerRoute))
    return GazetteerRoute;

  return HomeRoute;
};


const PageRouting = () => {
  return (
    <Switch>
      <AuthorizeRoute exact path={`${GazetteerRoute}/:usrn`} component={Gazetteerpage} />
      <AuthorizeRoute path={TaskManagementRoute} component={Taskmanagementpage} />
      <AuthorizeRoute path={UserAdminRoute} component={UserAdminpage} />
      <AuthorizeRoute path={MaintenanceRoute} component={Maintenancepage} />
      <Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />
      <AuthorizeRoute path="*" exact component={Homepage} />
    </Switch>
  )
};

export default withRouter(PageRouting);
